import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/question_mark_circle.png';
import _imports_1 from '@/assets/img/common/alipay.png';
import _imports_2 from '@/assets/icon/icon_unchecked.png';
import _imports_3 from '@/assets/icon/icon_checked.png';
import _imports_4 from '@/assets/img/common/wechat_pay.png';
const _withScopeId = n => (_pushScopeId("data-v-5cfd406a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "orderInfo p-t20 p-lr32 font-28" };
const _hoisted_2 = { class: "orderMsg border-r16 white-bg m-b20 p-lr20 p-tb24" };
const _hoisted_3 = { class: "flexBox h-44 m-b16" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "订单编号：", -1));
const _hoisted_5 = { class: "font-w500" };
const _hoisted_6 = { class: "flexBox m-b16 h-44" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "下单时间：", -1));
const _hoisted_8 = { class: "font-w500" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ig-border-b1 m-b16" }, null, -1));
const _hoisted_10 = { class: "flexBox m-b16 h-44" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "订单归属人：", -1));
const _hoisted_12 = { class: "font-w500" };
const _hoisted_13 = { class: "flexBox m-b16 h-44" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "手机号：", -1));
const _hoisted_15 = { class: "font-w500" };
const _hoisted_16 = { class: "orderMsg border-r16 m-b16 white-bg p-lr20 p-tb24" };
const _hoisted_17 = { class: "productList" };
const _hoisted_18 = { class: "flex" };
const _hoisted_19 = { class: "imgBox border-r16" };
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "info p-l24" };
const _hoisted_22 = { class: "title text-ell2 m-b16 font-w500 font-32" };
const _hoisted_23 = { class: "flexBox numBox" };
const _hoisted_24 = { class: "price font-w500 font-32" };
const _hoisted_25 = { class: "num" };
const _hoisted_26 = {
    key: 0,
    class: "orderMsg border-r16 white-bg m-b20 p-lr20 p-tb24"
};
const _hoisted_27 = { class: "flexBox h-44" };
const _hoisted_28 = { class: "gray-2" };
const _hoisted_29 = /*#__PURE__*/ _createTextVNode(" 你有 ");
const _hoisted_30 = { class: "deepRed" };
const _hoisted_31 = /*#__PURE__*/ _createTextVNode(" 张练习卡： ");
const _hoisted_32 = ["onClick"];
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "deepRed" }, "使用练习卡兑换", -1));
const _hoisted_34 = [
    _hoisted_33
];
const _hoisted_35 = { class: "orderMsg border-r16 white-bg m-b20 p-lr20 p-tb24" };
const _hoisted_36 = { class: "flexBox h-44" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "总价", -1));
const _hoisted_38 = { class: "font-w500" };
const _hoisted_39 = {
    key: 1,
    class: "orderMsg border-r16 white-bg m-b20 p-lr20"
};
const _hoisted_40 = { class: "gray-6" };
const _hoisted_41 = /*#__PURE__*/ _createTextVNode(" 折扣优惠 ");
const _hoisted_42 = { key: 0 };
const _hoisted_43 = /*#__PURE__*/ _createTextVNode(" ： ");
const _hoisted_44 = { class: "font-w500 deepRed" };
const _hoisted_45 = {
    key: 1,
    class: "flexBox m-b16 h-88"
};
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "优惠券优惠：", -1));
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
    key: 0,
    class: "deepRed font-w500"
};
const _hoisted_49 = {
    key: 1,
    class: "gray-9"
};
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "其他优惠：", -1));
const _hoisted_51 = { class: "font-w500 deepRed" };
const _hoisted_52 = {
    key: 2,
    class: "orderMsg border-r16 white-bg m-b20 p-lr20 p-tb24"
};
const _hoisted_53 = { class: "flexBox h-44" };
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "代付人登录后，可使用优惠和学币", -1));
const _hoisted_55 = {
    key: 3,
    class: "orderMsg border-r16 white-bg m-b20 p-lr20"
};
const _hoisted_56 = { class: "flexBox h-40 p-t24" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "代付人：", -1));
const _hoisted_58 = { class: "font-w500" };
const _hoisted_59 = { class: "flexBox m-b16 h-88" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-6" }, "代付人手机号：", -1));
const _hoisted_61 = {
    key: 4,
    class: "orderMsg border-r16 white-bg m-b20 p-lr20"
};
const _hoisted_62 = {
    key: 0,
    class: "flexBox p-tb24"
};
const _hoisted_63 = { class: "gray-6 flexBox" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "couponIcon" }, "可用学币", -1));
const _hoisted_65 = ["onClick"];
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_67 = [
    _hoisted_66
];
const _hoisted_68 = { class: "xuebi flexBox" };
const _hoisted_69 = { class: "gray-9" };
const _hoisted_70 = ["onClick"];
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "m-b16" }, null, -1));
const _hoisted_72 = { class: "flexBox m-b16 h-88" };
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "payIcon" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_1,
        alt: ""
    })
], -1));
const _hoisted_74 = {
    class: "icon-check",
    src: _imports_2,
    alt: ""
};
const _hoisted_75 = {
    class: "icon-check",
    src: _imports_3,
    alt: ""
};
const _hoisted_76 = { class: "flexBox h-88" };
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "payIcon" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_4,
        alt: ""
    })
], -1));
const _hoisted_78 = {
    class: "icon-check",
    src: _imports_2,
    alt: ""
};
const _hoisted_79 = {
    class: "icon-check",
    src: _imports_3,
    alt: ""
};
const _hoisted_80 = { class: "payBtnWrapper" };
const _hoisted_81 = { class: "payBtnBox flexBox p-lr32" };
const _hoisted_82 = { class: "num" };
const _hoisted_83 = { class: "price font-w500" };
const _hoisted_84 = {
    key: 0,
    class: "gray-6"
};
const _hoisted_85 = ["onClick"];
const _hoisted_86 = { class: "backTip" };
const _hoisted_87 = { class: "tipContent" };
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", null, "您的支付未完成是否继续支付？", -1));
const _hoisted_89 = ["onClick"];
const _hoisted_90 = ["onClick"];
import { ref, computed, getCurrentInstance } from 'vue';
import { getOrderDetail, getCouponList, updateCoupon, getOrderMsg, getWechatCodeInfo } from '@/api/pay';
import { appPort, wechatPort, userLogin, orderPay, prevPageView, isLogin, getUrlParam, getUserId } from '@/widget';
import { getUserInfo } from '@/api/user';
import { Toast } from 'vant';
import CouponList from './quan.vue';
import { hostPath, payApi2 } from '@/public/utils/basePath';
import { useRouter, useRoute } from 'vue-router';
import { exhangeCheck } from '@/api/exercise';
import orderHeader from './orderHeader.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        livePage: {
            type: String,
            default: ''
        }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const behalf = Number(getUrlParam('behalf')) == 1;
        const { proxy: { $showLoading, $hideLoading, $dialog } } = getCurrentInstance();
        const route = useRoute();
        const orderId = String(route.params.orderId);
        const module = String(route.params.module);
        const orderStatus = computed(() => {
            let obj = {
                pay: false,
                text: '确认支付'
            };
            obj.pay = orderInfo.value.orderPayStatus;
            if (orderInfo.value.orderPayStatus) {
                obj.text = '已支付';
            }
            else {
                obj.text = '确认支付';
            }
            if (behalf) {
                obj.text = '帮TA支付';
            }
            return obj;
        });
        // 学币控制
        const coinBl = ref(true);
        if (!/^OMO/.test(orderId)) {
            coinBl.value = false;
        }
        const selectCoin = () => {
            if (orderInfo.value.orderPayStatus) {
                return;
            }
            coinBl.value = !coinBl.value;
            getOrderInfo();
        };
        const showQuestion = () => {
            $dialog
                .alert({
                message: '学币目前适用在好医术平台购买部分课程，仅可使用 非iOS端充值 的学币。您可通过好医术官方渠道进行充值，更多请咨询您的专属顾问。',
                theme: 'round-button',
                title: '可用学币说明'
            })
                .then(() => { });
        };
        // 代付人信息
        const userInfo = ref({});
        const getUser = () => {
            let userId = getUserId();
            getUserInfo(userId).then((res) => {
                if (res.code == 200) {
                    userInfo.value = res.data.user;
                }
            });
        };
        const orderInfo = ref({});
        const isApp = appPort();
        const loaded = ref(false);
        const wechat = ref(wechatPort());
        const exchangeFlag = ref(false); // 是否能够兑换练习卡
        const cardCount = ref(0); // 练习卡数量
        const getOrderInfo = (couponId) => {
            $showLoading();
            if (behalf) {
                getOrderMsg({
                    orderId,
                    moduleType: module,
                    selectOption: coinBl.value
                }).then((res) => {
                    $hideLoading();
                    if (res.code == 200) {
                        loaded.value = true;
                        orderInfo.value = res.data;
                        if (orderInfo.value.balanceAmount <= 0) {
                            coinBl.value = false;
                        }
                        if (orderInfo.value.orderPayStatus) {
                            // 已支付订单
                            paySuccess();
                        }
                        else {
                            getUser();
                        }
                        if (orderStatus.value.pay) {
                            showBack.value = false;
                            coinBl.value = false;
                        }
                        else {
                            showBack.value = true;
                        }
                    }
                    else if (res.code == 6022) {
                        // 订单已支付
                        paySuccess();
                    }
                });
                return;
            }
            let query = {
                orderId: orderId,
                orderType: module,
                selectOption: coinBl.value,
                payOnBehalf: behalf
            };
            if (couponId) {
                query.couponId = couponId;
            }
            getOrderDetail(query).then((res) => {
                $hideLoading();
                if (res.code == 200) {
                    loaded.value = true;
                    orderInfo.value = res.data;
                    if (orderInfo.value.balanceAmount <= 0) {
                        coinBl.value = false;
                    }
                    if ((!couponId || orderInfo.value.couponAmount != 0) &&
                        !orderInfo.value.orderPayStatus &&
                        !behalf) {
                        // 获取优惠券列表
                        getCounpon(res.data.orderType);
                    }
                    if (orderInfo.value.orderType == 'omo') {
                        exhangeCheck({
                            courseId: orderInfo.value.productList[0].productId
                        }).then((res) => {
                            if (res.code == 200) {
                                exchangeFlag.value = res.data.hidden;
                                cardCount.value = res.data.cardCount;
                            }
                        });
                    }
                    if (orderInfo.value.orderPayStatus) {
                        // 已支付订单
                        paySuccess();
                    }
                    if (orderStatus.value.pay) {
                        showBack.value = false;
                        coinBl.value = false;
                    }
                    else {
                        showBack.value = true;
                    }
                }
                else if (res.code == 6022) {
                    // 订单已支付
                    paySuccess();
                }
                else if (res.code == 6008) {
                    $dialog
                        .alert({
                        message: res.message,
                        theme: 'round-button',
                        confirmButtonText: '切换账号'
                    })
                        .then(() => {
                        userLogin();
                    });
                }
            });
        };
        const paySuccess = () => {
            // 支付成功 进入支付成功页
            router.replace({
                path: `/order/payresult/${module}/${orderId}?backUrl=${getBackUrl()}`
            });
        };
        if (isLogin || behalf) {
            getOrderInfo();
        }
        else {
            $dialog
                .alert({
                message: '为保障你的账户安全,请登录此订单所属的手机号码进行支付',
                theme: 'round-button',
                confirmButtonText: '去登录'
            })
                .then(() => {
                userLogin();
            });
        }
        // 获取优惠券列表
        const counponList = ref([]);
        const counponStatus = ref('hide');
        const getCounpon = (type) => {
            getCouponList({ orderId: orderId, orderType: type }).then((res) => {
                if (res.code == 200) {
                    counponList.value = res.data;
                }
            });
        };
        const showTip = () => {
            // 没有优惠券不显示筛选优惠券
            if (counponList.value.length) {
                counponStatus.value = 'up';
            }
        };
        const closeTip = (id) => {
            if (id) {
                updateCoupon({
                    orderId,
                    orderType: orderInfo.value.orderType,
                    couponId: id
                }).then((res) => {
                    getOrderInfo(id);
                });
            }
            counponStatus.value = 'down';
            setTimeout(() => {
                counponStatus.value = 'hide';
            }, 320);
        };
        // 选择支付方式
        // paytype 微信支付 wechat（包含有学币抵扣） 支付宝支付 alipay（包含学币抵扣） 苹果支付 applePay（包含学币抵扣） balance 仅仅使用学币支付 freePay 免支付（0元订单）
        const payType = ref('alipay');
        if (wechat.value) {
            payType.value = 'wechat';
        }
        const checkType = (type) => {
            if (type === payType.value) {
                return;
            }
            if (isApp) {
                payType.value = type;
            }
            else {
                Toast(type == 'wechat' ? '当前环境不支持微信支付' : '当前环境不支持支付宝支付');
            }
        };
        const showBack = ref(false);
        const back = ref(false);
        const backFn = () => {
            if (back.value) {
                back.value = false;
                showBack.value = false;
                prevPage();
            }
            else if (showBack.value) {
                back.value = true;
            }
            else {
                back.value = false;
                showBack.value = false;
                prevPage();
            }
        };
        // 返回上一页
        const prevPage = () => {
            if (isApp) {
                prevPageView();
                return;
            }
            if (history.length > 2) {
                if (wechat.value) {
                    history.go(-2);
                }
                else {
                    history.go(-1);
                }
            }
            else {
                location.assign(hostPath);
            }
        };
        const payAgain = () => {
            back.value = false;
        };
        // 订单支付
        const payOrder = () => {
            let { payAmount, orderPayStatus, freePay } = orderInfo.value;
            if (orderPayStatus) {
                Toast('订单已支付');
                return;
            }
            if (freePay) {
                payType.value = 'freePay';
            }
            else if (payAmount == 0) {
                payType.value = 'balance';
            }
            $showLoading();
            orderPay(payType.value, { module: module }, {
                returnUrl: `${hostPath}/learn/order/payresult/${module}/${orderId}?backUrl=${getBackUrl()}`,
                orderId,
                selectOption: coinBl.value,
                payOnBehalf: behalf
            }, (msg) => {
                if (!msg || msg == 'ok') {
                    paySuccess();
                }
                else {
                    Toast(msg);
                }
            })
                .then(() => {
                $hideLoading();
            })
                .catch((msg) => {
                $hideLoading();
                Toast(msg || '支付失败，请稍后重试');
            });
        };
        const getBackUrl = () => {
            // const num = this.orderInfo.meetingType
            // @ts-ignore
            // let reffer = document.reffer
            // if (reffer && reffer != location.href) {
            //   return reffer
            // }
            return window.encodeURIComponent(`/course/omo`);
        };
        const wechatAuth = () => {
            // 微信 code 校验
            if (wechatPort()) {
                let base = payApi2 + '/wechat/auth?redirectURI=';
                let redirectUrl = window.encodeURIComponent(location.href);
                window.location.replace(base + redirectUrl);
            }
        };
        let openId = localStorage.getItem('openId') || '';
        let code = String(route.query.code || '');
        if (!openId && behalf && !code && wechatPort()) {
            // 没有 openId 没有code 获取 openId
            wechatAuth();
        }
        if (!!code && !openId) {
            //  获取 openId
            getWechatCodeInfo({
                code: code
            }).then(res => {
                if (res.code === 200) {
                    openId = res.data.openId;
                    localStorage.setItem('openId', openId);
                    // 去除链接中的code
                    router.replace({
                        path: route.path,
                        query: {
                            behalf: 1
                        }
                    });
                }
            });
        }
        // 练习卡兑换
        const toExchange = () => {
            let id = orderInfo.value.productList[0].productId;
            router.push({
                path: '/exchange/' + id
            });
        };
        if (isApp) {
            window.payCallback = () => {
                paySuccess();
            };
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (__props.livePage == '1' && _unref(isApp))
                    ? (_openBlock(), _createBlock(orderHeader, { key: 0 }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, _toDisplayString(orderInfo.value.orderId), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, _toDisplayString(orderInfo.value.orderTime), 1)
                        ]),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, _toDisplayString(orderInfo.value.userName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, _toDisplayString(orderInfo.value.userPhone), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("ul", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderInfo.value.productList || [], (item) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("img", {
                                            src: item.productImage,
                                            alt: ""
                                        }, null, 8, _hoisted_20)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.productName), 1),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("span", null, "¥ " + _toDisplayString(item.productAmount || orderInfo.value.productAmount), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, "x" + _toDisplayString(item.productCount), 1)
                                        ])
                                    ])
                                ]));
                            }), 256))
                        ])
                    ]),
                    (!exchangeFlag.value && !behalf && cardCount.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(cardCount.value), 1),
                                    _hoisted_31
                                ]),
                                _createElementVNode("div", {
                                    class: "rightIcon",
                                    onClick: _withModifiers(toExchange, ["stop"])
                                }, _hoisted_34, 8, _hoisted_32)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, "¥" + _toDisplayString(orderInfo.value.productAmount), 1)
                        ])
                    ]),
                    (orderInfo.value.discountAmount * 1 > 0 ||
                        orderInfo.value.managerAmount * 1 > 0 ||
                        !behalf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            (orderInfo.value.discountAmount * 1 > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["flexBox h-40 p-t24", {
                                            'p-b24': orderInfo.value.managerAmount * 1 == 0 && behalf
                                        }])
                                }, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _hoisted_41,
                                        (orderInfo.value.discountCardName)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, " （" + _toDisplayString(orderInfo.value.discountCardName) + "） ", 1))
                                            : _createCommentVNode("", true),
                                        _hoisted_43
                                    ]),
                                    _createElementVNode("div", _hoisted_44, " -¥" + _toDisplayString(orderInfo.value.discountAmount), 1)
                                ], 2))
                                : _createCommentVNode("", true),
                            (!behalf)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createElementVNode("div", {
                                        class: "rightIcon",
                                        onClick: _withModifiers(showTip, ["stop"])
                                    }, [
                                        (counponList.value.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, " -¥" + _toDisplayString(orderInfo.value.couponAmount), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_49, "暂无可用"))
                                    ], 8, _hoisted_47)
                                ]))
                                : _createCommentVNode("", true),
                            (orderInfo.value.managerAmount * 1 > 0)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["flexBox h-40 p-b24", { 'p-t24': behalf && orderInfo.value.discountAmount * 1 == 0 }])
                                }, [
                                    _hoisted_50,
                                    _createElementVNode("div", _hoisted_51, " -¥" + _toDisplayString(orderInfo.value.managerAmount), 1)
                                ], 2))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (!_unref(isLogin) && behalf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createElementVNode("div", {
                                    class: "font-w500 themeColor",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(userLogin)()), ["stop"]))
                                }, " 立即登录 ")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_unref(isLogin) && behalf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("span", null, _toDisplayString(userInfo.value.userName), 1),
                                    _createElementVNode("span", {
                                        class: "themeColor",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_unref(userLogin)()), ["stop"]))
                                    }, "  切换账号 ")
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                                _hoisted_60,
                                _createElementVNode("div", null, _toDisplayString(userInfo.value.phone?.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$2')), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (!orderInfo.value.freePay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            (_unref(isLogin) && orderInfo.value.orderType == 'omo')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                        _hoisted_64,
                                        _createElementVNode("div", {
                                            class: "questionIcon",
                                            onClick: _withModifiers(showQuestion, ["stop"])
                                        }, _hoisted_67, 8, _hoisted_65)
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_68, [
                                            _createElementVNode("div", _hoisted_69, "余额 " + _toDisplayString(orderInfo.value.balanceAmount) + " ", 1),
                                            (orderInfo.value.balanceAmount * 1 > 0)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    onClick: _withModifiers(selectCoin, ["stop"]),
                                                    class: _normalizeClass({ switchOn: coinBl.value, switchOff: !coinBl.value })
                                                }, null, 10, _hoisted_70))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (orderInfo.value.balanceAmount * 1 > 0)
                                            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "price useCoin font-w500"
                                            }, " -" + _toDisplayString(orderInfo.value.accountAmount), 513)), [
                                                [_vShow, coinBl.value]
                                            ])
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (orderInfo.value.payAmount * 1 > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_71,
                                    _createElementVNode("div", _hoisted_72, [
                                        _hoisted_73,
                                        _createElementVNode("div", {
                                            class: "radio",
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (checkType('alipay')), ["stop"]))
                                        }, [
                                            _withDirectives(_createElementVNode("img", _hoisted_74, null, 512), [
                                                [_vShow, payType.value != 'alipay']
                                            ]),
                                            _withDirectives(_createElementVNode("img", _hoisted_75, null, 512), [
                                                [_vShow, payType.value == 'alipay']
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_76, [
                                        _hoisted_77,
                                        _createElementVNode("div", {
                                            class: "radio",
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (checkType('wechat')), ["stop"]))
                                        }, [
                                            _withDirectives(_createElementVNode("img", _hoisted_78, null, 512), [
                                                [_vShow, payType.value !== 'wechat']
                                            ]),
                                            _withDirectives(_createElementVNode("img", _hoisted_79, null, 512), [
                                                [_vShow, payType.value === 'wechat']
                                            ])
                                        ])
                                    ])
                                ], 64))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, "￥" + _toDisplayString(orderInfo.value.payAmount), 1),
                            (orderInfo.value.totalDiscount * 100 > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, " 总计优惠￥" + _toDisplayString(orderInfo.value.totalDiscount), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["sureBtn font-28 font-w500", { disabled: orderInfo.value.orderPayStatus }]),
                            onClick: _withModifiers(payOrder, ["stop"])
                        }, _toDisplayString(_unref(orderStatus).text), 11, _hoisted_85)
                    ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_86, [
                    _createElementVNode("dl", _hoisted_87, [
                        _hoisted_88,
                        _createElementVNode("dd", null, [
                            _createElementVNode("div", {
                                class: "cancel",
                                onClick: _withModifiers(backFn, ["stop"])
                            }, "我放弃了", 8, _hoisted_89),
                            _createElementVNode("div", {
                                class: "continue",
                                onClick: _withModifiers(payAgain, ["stop"])
                            }, "继续支付", 8, _hoisted_90)
                        ])
                    ])
                ], 512), [
                    [_vShow, back.value && showBack.value]
                ]),
                _createVNode(CouponList, {
                    onCloseTip: closeTip,
                    list: counponList.value,
                    status: counponStatus.value,
                    couponId: orderInfo.value.couponId
                }, null, 8, ["list", "status", "couponId"])
            ]));
        };
    }
});
